import store from '@/store';

const isAuthenticatedGuard = async (to, from, next) => {
  const { status } = await store.dispatch('auth/checkAuthentication');

  const role = localStorage.getItem('role') ?? '';
  const routesAuth = [
    'login',
    'register',
    'forgot-password',
    'new-password',
    'email-confirmation',
    'reset-password',
  ];

  const routesUser = [
    'home',
    'email-confirmated',
    'dashboard-billing',
    'dashboard-accounts',
    'dashboard-collection',
    'dashboard-other-requests',
    'dashboard-profile',
    'wellcome',
  ];

  const routesAdmin = [
    'homeAdmin',
    'digitalLetters',
    'clients',
    'cashBillingAdmin',
    'cashContactsAdmin',
    'salesUsers',
  ]

  const routesMarketing = [
    'homeMarketing',
    'historyPayments',
    'cashBillingMarketing',
  ]

  // Cliente (2 y 3): nunca entra a pantallas de admin ni de ventas.
  if (
    status &&
    (routesAuth.includes(to.name) || routesAdmin.includes(to.name) || routesMarketing.includes(to.name)) &&
    (role === '2' || role === '3')
  ) {
    next({ name: 'dashboard-billing' });
  // Ventas (5): nunca entra a pantallas de admin.
  } else if (
    status &&
    (routesAuth.includes(to.name) || routesAdmin.includes(to.name)) &&
    role === '5'
  ) {
    next({ name: 'homeMarketing' });
  } else if (
    status &&
    (routesAuth.includes(to.name) || routesAdmin.includes(to.name) ) &&
    role === '1'
  ) {
    next();
  } else if (status && !routesAuth.includes(to.name)) {
    if(role==='1'){
      next({ name: 'homeAdmin' });
    }else{
      next();
    }
  } else if (!status && routesAuth.includes(to.name)) {
    next();
  } else {
    next({ name: 'login' });
  }
};

export default isAuthenticatedGuard;
